module.exports = __webpack_public_path__ + "static/media/savingsnew loanx3.6fd2acd7.svg";